import Interceptor from "@/plugins/interceptor";

const urlAPI = `${process.env.VUE_APP_URL_API}/unit`;

const unit = {
  state: {
    AllNeighborhoods: [],
    Neighborhoods: {}
  },
  actions: {
    getAllNeighborhoods({ commit }) {
      Interceptor.get(`${urlAPI}/neighborhoods`).then(res => {
        commit('SET_ALL_NEIGHBORHOODS', res.data);
      })
    },
    getNeighborhoods({ commit }) {
      Interceptor.get(`${urlAPI}/neighborhood/owner`).then(res => {
        commit('SET_NEIGHBORHOODS', res.data);
      })
    },
    getUnits(_, neighborhoodId) {
      return new Promise((resolve) => {
        Interceptor.get(`${urlAPI}/neighborhood/${neighborhoodId}/units/owner`)
          .then(res => {
            resolve(res.data);
          });
      });
    },
  },
  mutations: {
    SET_ALL_NEIGHBORHOODS(state, value) {
      state.AllNeighborhoods = value
    },
    SET_NEIGHBORHOODS(state, value) {
      state.Neighborhoods = value
    }
  }
}

export default unit;
